/**
 * Billing periods for the period toggle from BE `available_periods`.
 *
 * @param {{ available_periods?: number[] }|null|undefined} currentOffer
 * @returns {number[]}
 */
const getAvailablePeriods = currentOffer => {
  const available = currentOffer?.available_periods;
  if (!Array.isArray(available) || available.length === 0) {
    return [];
  }

  return [
    ...new Set(available.filter(p => typeof p === "number" && !Number.isNaN(p)))
  ].sort((a, b) => a - b);
};

export default getAvailablePeriods;
